import { CommonModule } from '@angular/common';
import { Component, HostListener, Renderer2 } from '@angular/core';
import { TypoComponent } from '../typo/typo.component';
import { LogoComponent } from '../logo/logo.component';

@Component({
  selector: 'berry-screen-size-not-supported',
  standalone: true,
  imports: [CommonModule, TypoComponent, LogoComponent],
  template: `
    <div *ngIf="isSmallScreen" class="overlay">
      <berry-logo [style]="'large'"></berry-logo>
      <berry-typo [color]="'primary'">لا يمكن عرض الصفحة بهذا الحجم، الرجاء تكبير المتصفح ليلائم كامل الشاشة، لمزيد من المعلومات الرجاء مراجعة مدير النظام</berry-typo>
    </div>
  `,
  styleUrls: ['./screen-size-not-supported.component.scss']
})
export class ScreenSizeNotSupportedComponent {
  isSmallScreen: boolean = false;

  constructor(private renderer: Renderer2,) { }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  ngOnInit() {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isSmallScreen = window.innerWidth < 1200;

    if (this.isSmallScreen) {
      this.renderer.addClass(document.body, 'no-overflow');
    } else {
      this.renderer.removeClass(document.body, 'no-overflow');
    }
  }
}